import { render, staticRenderFns } from "./PhoneNumberPorting.vue?vue&type=template&id=21297bc2&scoped=true&"
import script from "./PhoneNumberPorting.vue?vue&type=script&lang=js&"
export * from "./PhoneNumberPorting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21297bc2",
  null
  
)

export default component.exports